import React from 'react';
import { useTheme } from 'styled-components';

import { useScreenSizeDetection } from 'common/hooks';
import { Flex } from 'components/styled/Flex';
import { FormHeading } from 'components/styled/Form.styled';

export const TotalPriceUnderTable = ({
  title,
  amount,
  margin,
}: {
  title?: string;
  amount?: string | number;
  margin?: string;
}) => {
  const { isMobile } = useScreenSizeDetection();
  const { colors } = useTheme();

  return (
    <Flex
      margin={margin || '1.125rem 0 0 0'}
      justifyContent="space-between"
      border="1px solid #EDEDED"
      borderRadius="0.5rem"
      padding="1rem"
      width={isMobile ? '100%' : '50%'}
      backgroundColor={colors.white}
    >
      <FormHeading mb="0">{title}</FormHeading>
      <FormHeading mb="0">{amount}</FormHeading>
    </Flex>
  );
};
